import React from 'react';
import { PricePerDayWrapper, PricePerDayValue, PricePerDaySubtext } from './styled';
export var DATA_TEST_PPD_WRAPPER = 'price-per-day';
export var DATA_TEST_PPD_VALUE = 'price-per-day-value';
var PricePerDay = function PricePerDay(_ref) {
  var monthlyPrice = _ref.monthlyPrice;
  if (monthlyPrice) {
    return /*#__PURE__*/React.createElement(PricePerDayWrapper, {
      "data-test": DATA_TEST_PPD_WRAPPER
    }, "$", monthlyPrice, "/month", ' ', /*#__PURE__*/React.createElement(PricePerDaySubtext, null, "(Works out to", ' ', /*#__PURE__*/React.createElement(PricePerDayValue, {
      "data-test": DATA_TEST_PPD_VALUE
    }, "$", (monthlyPrice / 30).toPrecision(2), "/day"), ")"));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default PricePerDay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/PricePerDay/PricePerDay.js
// module id = 4013
// module chunks = 11